import { defineMessages } from 'react-intl';

import type { i18nType } from '../../../../../common/types';

type FilterLabelsType = Record<string, i18nType>;

export const i18n: FilterLabelsType = defineMessages({
	clearFilters: {
		id: 'search-page.filters.dropdown.clear-filters',
		defaultMessage: 'Clear filters',
		description: 'Label for clearing filters in the dropdown',
	},
	dropdownButtonLabel: {
		id: 'search-page.filters.dropdown.button',
		defaultMessage: 'More filters',
		description: 'Accesssibility label for an icon button to display more filters',
	},
});
